// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const firebase = {
  config: getConfig()
};
function getConfig() {
  let config;
  let request = new XMLHttpRequest();
  try {
   
    return {
        apiKey: "AIzaSyCDXpcOpzPJCR9gy8cF7UySpeuBeS--tdo",
        authDomain: "p3-eva.firebaseapp.com",
        projectId: "p3-eva",
        storageBucket: "p3-eva.appspot.com",
        messagingSenderId: "400962735224",
        appId: "1:400962735224:web:280d58330815d356aa318d"
      };
      /*
      request.open('GET', 'rest/environmentinfo', false);  // `false` makes the request synchronous
      request.send(null);

      if (request.status === 200) {
          const res = JSON.parse(request.responseText)
          if(res && res.envInfo && res.envInfo.firebase_auth_json)
          config = JSON.parse(res.envInfo.firebase_auth_json);
      }

      return config; */
  } catch (e) {
      console.error('environment:getConfig: unable to get api key : ', e);
  }

  return config;
}